import { DeleteRounded } from "@mui/icons-material";
import { useElements } from "../editorTabs/tabPanel/useElements";
import { observer } from "mobx-react-lite";
import { TooltipIconButton } from "./TooltipIconButton";
import { TooltipActionProps } from "../EditorTooltip";

export const Remove = observer(({ store }: TooltipActionProps) => {
  const { deleteSelectedElements } = useElements(store);

  return (
    <TooltipIconButton onClick={deleteSelectedElements}>
      <DeleteRounded fontSize="small" />
    </TooltipIconButton>
  );
});
